import Icon from '../../../../app/shared/components/Icon/Icon';
import { FamilyDetailsModalTranslation } from '../../../localization/ModuleTranslation';
import { PricelistProductFamilyDetailsData } from '../../../model';
import Brand from '../../../shared/Brand/Brand';
import Button from '../../../ui/Button/Button';
import Markdown from '../../../ui/Markdown/Markdown';
import { Modal, ModalBody, ModalContent, ModalHeader, ModalHeading } from '../../../ui/Modal/Modal';
import css from './FamilyDetailsModal.css';

interface FamilyDetailsModalProps {
  data: PricelistProductFamilyDetailsData;
  translation: FamilyDetailsModalTranslation;
}

const FamilyDetailsModal = ({ data, translation }: FamilyDetailsModalProps) => {
  return (
    <Modal>
      <Button theme="primary" variant="ghost">
        <Icon name="book" className={css.icon} /> {translation.triggerLabel}
      </Button>
      <ModalContent>
        <ModalHeader className={css.header} closeLabel={translation.closeLabel}>
          <Brand brandId={data.brandId} brandName={data.brandName} />
          <ModalHeading>{data.name}</ModalHeading>
        </ModalHeader>
        <ModalBody>
          {data.description && (
            <section className={css.section}>
              <h3 className={css.subheading}>{translation.descriptionHeading}</h3>
              <p className={css.description}>{data.description}</p>
            </section>
          )}
          {data.keyFeatures && (
            <section className={css.section}>
              <h3 className={css.subheading}>{translation.featuresHeading}</h3>
              <Markdown content={data.keyFeatures} />
            </section>
          )}
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default FamilyDetailsModal;
